import { formActionTypes,UPDATEFORM,RESETFORM } from "../types/userManagementTypes"


export const updateForm = (field:string , value:any)=>({
    type:UPDATEFORM,
    payload:{field,value}
});

export const resetForm =()=>({
    type:RESETFORM
});